import axios from '../axios';

export default {
  post(opportunityId, data) {
    return axios.post(`/opportunities/${opportunityId}/wish.json`, { wish: data });
  },
  decline(opportunityId, reason) {
    return axios.post(`/opportunities/${opportunityId}/wish/decline.json`, { reason });
  },
};
